'use client';

import { Show, SignUpButton } from '@clerk/nextjs';
import { useConfig } from '@marine/configs';
import { Button } from 'antd';
import { ArrowRight } from 'lucide-react';
import { useOpenPanel } from 'providers';
import { useCallback } from 'react';

export default function SignUpBtn() {
  const { theboatAppUrl } = useConfig();

  const openPanel = useOpenPanel();

  const trackSignUp = useCallback(async () => {
    openPanel.track('sign_up', { source: 'Index Page Jumbotron' });
  }, [openPanel.track]);

  return (
    <>
      <Show when="signed-in">
        <Button href={theboatAppUrl} className="ant-btn-special" size="large">
          Go to Dashboard <ArrowRight size={16} />
        </Button>
      </Show>
      <Show when="signed-out">
        <SignUpButton>
          <Button onClick={trackSignUp} className="ant-btn-special" size="large">
            Get started <ArrowRight size={16} />
          </Button>
        </SignUpButton>
      </Show>
    </>
  );
}
